import { render, staticRenderFns } from "./PgaTechAreasIndex.vue?vue&type=template&id=3f17b406&"
import script from "./PgaTechAreasIndex.vue?vue&type=script&lang=ts&"
export * from "./PgaTechAreasIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f17b406')) {
      api.createRecord('3f17b406', component.options)
    } else {
      api.reload('3f17b406', component.options)
    }
    module.hot.accept("./PgaTechAreasIndex.vue?vue&type=template&id=3f17b406&", function () {
      api.rerender('3f17b406', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/TechAreas/Components/PgaTechAreasIndex.vue"
export default component.exports